import { styled } from "@mui/material/styles";
import { Grid, Box } from "@mui/material";
import { useColors } from "../../Context/ColorsContext"
import { MediaQuerys } from "../../styles/GlobalStyle";

const { mobile, desktop } = MediaQuerys;

export const Content = styled(Grid)(() => {
    const { colors } = useColors();
    return {
        background: colors.gray,
        width: '100%',
        height: '100%'
    }
})

export const BoxModal = styled(Box)(() => ({
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
}))

export const ModalContainer = styled('div')(() => ({
    display: 'flex',
    width: '100%',
    minWidth: '500px',
    height: '100%',
    flexDirection: 'column',
    [mobile]: {
        minWidth: '380px',
    }
}))

export const ModalHeader = styled('div')(() => {
    const { colors } = useColors();
    return {
        display: 'flex',
        background: colors.white,
        color: colors.detailTextColor,
        width: '100%',
        height: 'fit-content',
        borderRadius: '10px 10px 0 0',
        padding: '16px',
        textTransform: 'uppercase',
        fontWeight: 600,
        [desktop]: {
            fontSize: '0.85rem',
        },
    }
})

export const ModalBody = styled('div')(() => {
    const { colors } = useColors();
    return {
        display: 'flex',
        flexDirection: 'column',
        flex: '1',
        width: '100%',
        background: colors.white,
        padding: '16px',
    }
})

export const ModalFooter = styled('div')(() => {
    const { colors } = useColors();
    return {
        display: 'flex',
        background: colors.white,
        width: '100%',
        height: 'fit-content',
        borderRadius: '0 0 10px 10px',
        justifyContent: 'flex-end',
        alignItems: 'center',
        padding: '8px 16px',
        margin: 'auto',
        gap: '8px',
    }
})
